import {
  forgotPassword,
  loginAdmin,
  logOutAdmin,
  resetPassword,
} from "store/services/session/auth.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { openToast } from "store/slices/common/toast.slice.js";
import { getApiMessage } from "utils/apiErrorCode";

export const LoginAdminAction = createAsyncThunk(
  "login/loginAdmin",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await loginAdmin(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const LogOutAdminAction = createAsyncThunk(
  "login/logOutAdmin",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await logOutAdmin();
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue({ response: res });
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const ForgotPasswordAction = createAsyncThunk(
  "login/forgotPassword",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await forgotPassword(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        return fulfillWithValue({ response: res });
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const ResetPasswordAction = createAsyncThunk(
  "login/resetPassword",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await resetPassword(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
